import { User } from '../../../graphql.generated';
import {
    trackEvent,
    identifyUser,
    BaseTaxonomy,
    EventNamesList
} from '@zoopla/tracking';
import { Segment } from '../AuthModal.types';

const getRegTaxonomy = (user: User, segment: Segment): BaseTaxonomy => {
    return {
        countryCode: 'gb',
        platform: 'React',
        brand: 'zoopla',
        userId: user.userUuid || '',
        brandPrimary: user.brandPrimary || '',
        aboutMeStatus: user.senderPropertyStatus || '',
        signedInStatus: user.loggedIn ? 'signed in' : 'signed out',
        registrationPlatform: user.registrationSources?.join(', '),
        registered: user.registered,
        userCreationDate: user.creationDate,
        section: segment?.section || 'unknown',
        page: segment?.page || 'unknown',
        activity: segment?.activity || 'unknown'
    } as BaseTaxonomy;
};

const getOptinTaxonomy = (user: User, segment: Segment): BaseTaxonomy => ({
    brand: 'zoopla',
    section: segment.section as BaseTaxonomy['section'],
    page: segment.page as BaseTaxonomy['page'],
    activity: segment.activity as BaseTaxonomy['activity'],
    userId: user.userUuid || ''
});

const eventTrackingMap: Record<string, EventNamesList> = {
    reg: 'Registration',
    signin: 'Sign In',
    optin: 'Email Marketing Opt-In'
};

export const trackAuthSegmentEvent = async (
    event: keyof typeof eventTrackingMap,
    segment: Segment | undefined,
    userData: User
) => {
    if (!segment) return;

    const eventName = eventTrackingMap[event];

    if (event === 'optin') {
        trackEvent(eventName, getOptinTaxonomy(userData || {}, segment));

        return;
    }

    if (userData) {
        const taxonomy = getRegTaxonomy(userData, segment);

        if (userData?.userUuid) identifyUser(window, userData.userUuid);
        trackEvent(eventName, taxonomy);
    }
};
